import { useTheme } from 'styled-components';
import { BodyLoader, Chart, InteractiveChartWrapper } from './styles';

export const InteractiveChartLoader = () => {
  const { colors } = useTheme();

  return (
    <InteractiveChartWrapper>
      <BodyLoader
        backgroundColor={colors.surface.interactiveDefault}
        foregroundColor={colors.surface.pressed}
      >
        <Chart />
      </BodyLoader>
    </InteractiveChartWrapper>
  );
};
